import { css } from '@emotion/react'
import {
  CornerRadius,
  gemVar,
  Spacing,
  ThemedColors,
  Typography,
} from '@opallabs/gem'

export const cssVariables = {
  placeholderWidth: '--token-strip-placeholder-width',
} as const

export const root = css({
  alignItems: 'center',
  backgroundColor: gemVar(ThemedColors.Surface1),
  borderBottom: `1px solid ${gemVar(ThemedColors.Surface3)}`,
  display: 'flex',
  flexFlow: 'row wrap',
  // The menu container is a flex column with a max-height, so without this
  // the scrolling option list would squeeze the strip.
  flexShrink: 0,
  gap: Spacing.XS,
  padding: Spacing.S,
})

export const token = css({
  ...Typography.T300,
  alignItems: 'center',
  backgroundColor: gemVar(ThemedColors.Surface2),
  border: `1px solid ${gemVar(ThemedColors.StrokeSecondary2)}`,
  borderRadius: CornerRadius.Small,
  boxSizing: 'border-box',
  color: gemVar(ThemedColors.TextPrimary),
  columnGap: Spacing.XS,
  display: 'flex',
  height: Spacing.L,
  maxWidth: '100%',
  padding: `0 ${Spacing.XS}px`,

  '&[data-pending=true]': {
    backgroundColor: gemVar(ThemedColors.Surface1),
    borderStyle: 'dashed',
    color: gemVar(ThemedColors.TextSecondary),
  },
})

export const tokenLabel = css({
  cursor: 'default',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const tokenRemove = css({
  alignItems: 'center',
  background: 'none',
  border: 'none',
  borderRadius: CornerRadius.XSmall,
  color: 'inherit',
  cursor: 'pointer',
  display: 'flex',
  padding: 0,
})

export const input = css({
  ...Typography.T500,
  backgroundColor: 'transparent',
  border: 'none',
  color: gemVar(ThemedColors.TextPrimary),
  // Wrap to a new line rather than clip the placeholder
  flex: `1 1 var(${cssVariables.placeholderWidth})`,
  minWidth: `var(${cssVariables.placeholderWidth})`,
  outline: 'none',
  padding: 0,

  '&::placeholder': {
    color: gemVar(ThemedColors.TextSecondary),
  },
  // `type="search"` gives the input its searchbox role, but WebKit
  // also draws a clear button for it, which the token strip shouldn't
  // show.
  '&::-webkit-search-cancel-button': {
    WebkitAppearance: 'none',
    display: 'none',
  },
})
